import React, { useState } from "react"
import style from './TipCalculater.module.css'

const TipCalculater = (props) => 
{

  const [tip,setTip]=useState(0);
  const [total,setTotal] = useState(0);
  /*
  const blackSpan = {
      color: "white",
      width: "85px",
      height: "34px",
      background: "hsl(183, 100%, 15%)",
      textAlign: "center",
      fontSize: "20px",
      bordeRadius:"5px"
     }
    */
   
     function Tip(event)
     {
      
       if(event.target.id=='5%')
       {
          setTip(0.05/parseInt(document.getElementById('NoOfPeople').value));
          document.getElementById('CustomTip').value = '';
       }

       else if(event.target.id == '10%')
       {
          setTip(0.10/parseInt(document.getElementById('NoOfPeople').value));
          document.getElementById('CustomTip').value = '';
       }

       else if(event.target.id == '15%')
       {
         setTip(0.15/parseInt(document.getElementById('NoOfPeople').value));
         document.getElementById('CustomTip').value = '';
       }
       
       else if(event.target.id == '25%')
       {
         setTip(0.25/parseInt(document.getElementById('NoOfPeople').value));
         document.getElementById('CustomTip').value = '';
       }

       else if(event.target.id =='50%')
       {
         setTip(0.5/parseInt(document.getElementById('NoOfPeople').value));
         document.getElementById('CustomTip').value = '';
       }

       else
       {
           let randomTip = parseInt(event.target.value)/100;
            
          setTip(randomTip/parseInt(document.getElementById('NoOfPeople').value))
       }

     }

     function RandomTip(event)
     {
         setTip(event.target.value);
     }

     function CalculateTotalPerPerson(event)
     {  
        
        if(event.target.value=='')
         {
            setTotal(0);  
         }

        else
        {
          if(document.getElementById('Bill').value !='')
          {
            let bill = document.getElementById('Bill').value;
            bill= parseInt(bill);
            let numberOfPeople = parseInt(document.getElementById('NoOfPeople').value);
            setTotal(bill/numberOfPeople);
          }    
        }
     }

    function Reset()
    {
       setTip(0);
       setTotal(0);
       document.getElementById('Bill').value = '';
       document.getElementById('NoOfPeople').value = '';
       document.getElementById('CustomTip').value = '';
    }


  return (
    <div className={style.mainContainer}>
    <div className={style.leftSection}>
     <h1>Bill</h1>
     <input type="text" onChange={CalculateTotalPerPerson} id="Bill" className="form-control" placeholder="$"></input>
     <br></br>
     <h1>Select Tip %</h1>
     <div className={style.row}>
     <span id='5%' onClick={Tip} className={style.blackSpan}>5%</span>  
     <span id = '10%' onClick={Tip} className={style.blackSpan}>10%</span>  
     <span id='15%' onClick={Tip} className={style.blackSpan}>15%</span>  
     </div>
     <br></br>
     <div className={style.row}>
     <span id='25%' onClick={Tip} className={style.blackSpan}>25%</span>  
     <span id='50%' onClick={Tip} className={style.blackSpan}>50%</span>
     <input type="text" id="CustomTip" onChange={Tip} style={{width:'40%'}} className="form-control" placeholder='Custom'/>
     </div>
     
    <h1>Number of People</h1>
    <input onChange={CalculateTotalPerPerson} type="text"  id='NoOfPeople'  className="form-control" placeholder="🕴"/>
    </div>

    <div className={style.rightSection}>
     <div className={style.tipAmount}>
     <h2 style={{color:'white',fontSize:'14px',fontFamily:'Space Mono'}}>Tip Amount <br></br> / <span style={{color:'hsl(186, 14%, 43%)'}}>person</span></h2>
     <br></br>
     <h2 style={{color:'hsl(185, 41%, 84%)',fontWeight:'700',fontFamily:'Space Mono'}}>${tip}</h2>
     </div>

     <div className={style.totalPerPerson}>
     <h1 style={{color:'white',fontSize:'14px',fontFamily:'Space Mono'}}> Total <br></br>/ <span style={{color:'hsl(186, 14%, 43%)'}}>person</span></h1>
     <br></br>
     <h2 style={{color:'hsl(185, 41%, 84%)',fontWeight:'700',fontFamily:'Space Mono'}}>${total}</h2>
     </div>
     <div className={style.resetButton}>
     <button type="button" onClick={Reset} style={{width:"250px", fontWeight:'bold',marginBottom:"20px",background:'hsl(172, 67%, 45%)'}} className="btn btn-secondary">RESET</button>
     </div>
    </div>  
    </div>
  )
};

export default TipCalculater;
